import styles from "./FJTextAreaBox.module.less";
import React, {useState} from "react";

function FJTextAreaBox(props) {
  const {placeholder, onChange, value} = props;
  const [changeType, updateChangeType] = useState('');
  const _onFocus = () => {
    updateChangeType('');
  };
  const _onBlur = (e) => {
    let curType = 'changeEnd';
    updateChangeType(curType);
    onChange(curType, e.target.value);
  };
  const _onChange = (e) => {
    let curType = changeType ? 'change' : 'changeStart';
    updateChangeType(curType);
    onChange(curType, e.target.value);
  };

  return (
    <div className={styles.textarea}>
      <textarea placeholder={placeholder}
                onFocus={_onFocus}
                onBlur={_onBlur}
                onChange={_onChange}
                value={value}
      />
    </div>
  )
}

export default FJTextAreaBox;